<div class="box-container" bsModal #modal>
    <h1 class="popup-title" mat-dialog-title>
        <div>
            <span class="number" [ngClass]="{'with-risk': isRisk}">{{ box_level }}</span>
            <span class="level">Уровень: {{ box_title }}</span>
        </div>
        <button mat-stroked-button class="close" aria-hidden="true" (click)="closeClicked()">×</button>
    </h1>
    <div class="content-container select_job_type_cnt">
        <div class="task">
            <div class="header">
                <span>Задания в варианте</span>
                <span class="subtopics-remove-icon">
                    <app-svg-icon [src]="removeIcon" class="delete"
                        (click)="removeFromAllChoosedSubtopics()"></app-svg-icon>
                </span>
            </div>
            <div class="task__block">
                <div class="content task-list-content">
                    <ul>
                        <li *ngFor="let subtopic of startSubtopics">
                            <span class="subtopic-title" title="{{ subtopic.file_comments }}">{{ subtopic.subtopic_title }}</span>
                            <span class="subtopic-remove-icon"><app-svg-icon [src]="removeIcon" class="delete"
                                (click)="removeFromChoosed(subtopic)"></app-svg-icon></span>
                        </li>
                    </ul>
                </div>
                <button mat-raised-button class="btn" [disabled]="startSubtopics.length == 0" (click)="enterClicked()">
                    Ввод
                </button>
            </div>
        </div>
        <div class="list_task_types">
            <div class="header">
                Список типов заданий
            </div>
            <div class="content task_content">
                <ul>
                    <li *ngFor="let subtopic of subtopics" title="{{ subtopic.file_comments }}"
                        (click)="chooseSubtopic(subtopic)">
                        <span class="fa fa-long-arrow-left"></span>{{ subtopic.subtopic_title }}
                    </li>
                </ul>
            </div>
        </div>
        <div class="filters">
            <div class="header">
                Фильтры
            </div>
            <div class="content"
                 *ngIf="!!themeForm"
                 [formGroup]="themeForm">
                <div class="title">
                    Название
                </div>

                <div class="search">
                    <form>
                        <input
                                type="text"
                                matInput
                                placeholder="сложение с переходом через десяток..."
                                [(ngModel)]="titleString"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="filterFilesByAttr()">

                    </form>
                </div>

                <div class="type">
                    <div class="title">
                        Формат
                    </div>

                    <div class="radio-group" >
                        <div *ngFor="let v of radioOrder" class="type-input">
                            <input type="radio"
                                   formControlName="type"
                                   class="radio"
                                   [value]="v.title">
                            <label>{{v.title}}</label>
                        </div>
                    </div>

                </div>

                <div class="themes">
                    <div class="title">
                        Темы
                    </div>
                    <input type="checkbox"
                           formControlName="all"
                           class="checkbox"
                           (click)="checkAllthemes(true)">
                    Все
                    <div formArrayName="themes">
                        <div *ngFor="let theme of themeForm.get('themes').controls; let i = index"
                             [formGroup]="theme">
                            <input type="checkbox"
                                   formControlName="val"
                                   class="checkbox" (click)="checkAllthemes(false)">
                            {{ i + 1 }}.{{ theme.value.label }}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
